<template>
  <div class="tab_content">
    <p class="tab_title">交易信息</p>
    <div class="tab_form">
      <el-form ref="form" :rules="rules" :model="form" label-width="200px">

        <!-- 基本交易信息 -->
        <el-form-item label="交易底价金额（万元）">
          <el-input-number
            :value="calculatedFloorPrice"
            :disabled="true"
            :precision="2"
            style="width: 200px"
          />
          <span class="hint">（自动计算，等于各业务类型底价之和）</span>
        </el-form-item>

        <el-form-item label="补充交易条件">
          <el-input v-model="form.additionCondition" type="textarea" :rows="3" placeholder="请输入" />
        </el-form-item>

        <el-form-item label="是否优先受让">
          <el-radio-group v-model="form.priorityTransferee">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 转让业务 -->
        <template v-if="hasTransfer">
          <div class="section-divider">转让业务</div>
          <el-form-item label="转让底价金额（万元）" prop="transferFloorPrice">
            <el-input-number
              v-model="form.transferFloorPrice"
              :min="0"
              :precision="2"
              placeholder="请输入"
              style="width: 200px"
            />
          </el-form-item>
          <el-form-item label="与转让相关的其他条件">
            <el-input v-model="form.transferOtherConditions" type="textarea" :rows="3" placeholder="请输入" />
          </el-form-item>
        </template>

        <!-- 许可业务 -->
        <template v-if="hasLicense">
          <div class="section-divider">许可业务</div>

          <el-form-item label="知识产权许可类型" prop="licenseType">
            <el-radio-group v-model="form.licenseType">
              <el-radio label="普通许可">普通许可</el-radio>
              <el-radio label="独占许可">独占许可</el-radio>
              <el-radio label="排他许可">排他许可</el-radio>
              <el-radio label="开放许可">开放许可</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 普通/独占/排他许可 -->
          <template v-if="form.licenseType && form.licenseType !== '开放许可'">
            <el-form-item label="许可底价金额（万元）" prop="licenseFloorPrice">
              <el-input-number
                v-model="form.licenseFloorPrice"
                :min="0"
                :precision="2"
                style="width: 200px"
              />
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="交叉许可">
                  <el-checkbox v-model="form.licenseTypeCross">交叉许可</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="分许可">
                  <el-checkbox v-model="form.licenseTypeFraction">分许可</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="许可时间">
                  <el-input v-model="form.licenseTime" placeholder="请输入" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="许可期限">
                  <el-date-picker
                    v-model="licenseDateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="许可范围">
              <el-input v-model="form.licenseScope" type="textarea" :rows="3" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="与许可相关的其他条件">
              <el-input v-model="form.licenseOtherConditions" type="textarea" :rows="3" placeholder="请输入" />
            </el-form-item>
          </template>

          <!-- 开放许可 -->
          <template v-if="form.licenseType === '开放许可'">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="交叉许可">
                  <el-checkbox v-model="form.licenseTypeCross">交叉许可</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="分许可">
                  <el-checkbox v-model="form.licenseTypeFraction">分许可</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="国知局公告声明编号" prop="licenseGzjNumber">
                  <el-input v-model="form.licenseGzjNumber" placeholder="请输入" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="公告发文日期" prop="licenseGzjDate">
                  <el-date-picker
                    v-model="form.licenseGzjDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="知识产权许可方式" prop="openLicenseMethod">
              <el-checkbox-group v-model="form.openLicenseMethod">
                <el-checkbox label="普通许可">普通许可</el-checkbox>
                <el-checkbox label="独占许可">独占许可</el-checkbox>
                <el-checkbox label="排他许可">排他许可</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="许可期限-开始" prop="licenseStart">
                  <el-date-picker
                    v-model="form.licenseStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="许可期限-结束" prop="licenseEnd">
                  <el-date-picker
                    v-model="form.licenseEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="知识产权许可金额（万元）" prop="licenseAmount">
              <el-input-number
                v-model="form.licenseAmount"
                :min="0"
                :precision="2"
                style="width: 200px"
              />
            </el-form-item>
            <el-form-item label="是否自行实施专利" prop="licenseCustom">
              <el-radio-group v-model="form.licenseCustom">
                <el-radio label="是 已自行实施专利技术">是 已自行实施专利技术</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <template v-if="form.licenseCustom === '是 已自行实施专利技术'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="自行实施时间">
                    <el-date-picker
                      v-model="form.licenseCustomDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                      style="width: 100%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="实施方式">
                    <el-input v-model="form.licenseCustomStyle" placeholder="请输入" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="实施范围">
                <el-input v-model="form.licenseCustomScope" type="textarea" :rows="2" placeholder="请输入" />
              </el-form-item>
            </template>
            <el-form-item label="是否许可他人实施专利" prop="licenseOther">
              <el-radio-group v-model="form.licenseOther">
                <el-radio label="是 已许可他人实施专利">是 已许可他人实施专利</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <template v-if="form.licenseOther === '是 已许可他人实施专利'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="许可他人实施时间">
                    <el-date-picker
                      v-model="form.licenseOtherDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                      style="width: 100%"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="许可他人实施范围">
                <el-input v-model="form.licenseOtherScope" type="textarea" :rows="2" placeholder="请输入" />
              </el-form-item>
            </template>
            <el-form-item label="与许可相关的其他条件">
              <el-input v-model="form.licenseOtherConditions" type="textarea" :rows="3" placeholder="请输入" />
            </el-form-item>
          </template>
        </template>

        <!-- 作价入股业务 -->
        <template v-if="hasStock">
          <div class="section-divider">作价入股业务</div>
          <el-form-item label="作价入股底价金额（万元）" prop="stockFloorPrice">
            <el-input-number
              v-model="form.stockFloorPrice"
              :min="0"
              :precision="2"
              style="width: 200px"
            />
          </el-form-item>
          <el-form-item label="知识产权作价入股企业状态">
            <el-select v-model="form.enterpriseStatus" placeholder="请选择" style="width: 240px">
              <el-option label="拟设立企业" value="拟设立企业" />
              <el-option label="已设立企业" value="已设立企业" />
            </el-select>
          </el-form-item>
          <el-form-item label="遴选方式">
            <el-radio-group v-model="form.selectionMethod">
              <el-radio label="公开挂牌">公开挂牌</el-radio>
              <el-radio label="其他">其他</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="与作价入股相关的其他条件">
            <el-input v-model="form.stockOtherConditions" type="textarea" :rows="3" placeholder="请输入" />
          </el-form-item>
        </template>

        <!-- 其他业务 -->
        <template v-if="hasOther">
          <div class="section-divider">其他业务</div>
          <el-form-item label="其他底价金额（万元）" prop="otherFloorPrice">
            <el-input-number
              v-model="form.otherFloorPrice"
              :min="0"
              :precision="2"
              style="width: 200px"
            />
          </el-form-item>
          <el-form-item label="与其他业务相关的其他条件">
            <el-input v-model="form.otherOtherConditions" type="textarea" :rows="3" placeholder="请输入" />
          </el-form-item>
        </template>

        <div class="button flex-center">
          <el-button type="primary" @click="$emit('aChange', 'tab3')">上一步</el-button>
          <el-button type="primary" @click="doStaging('form')">暂存</el-button>
          <el-button type="primary" @click="doSubmit('form')">下一步</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id", "cfrom"],
  data() {
    return {
      licenseDateRange: [],
      form: {
        additionCondition: "",
        priorityTransferee: "否",
        transferFloorPrice: null,
        transferOtherConditions: "",
        licenseType: "",
        licenseFloorPrice: null,
        licenseTypeCross: false,
        licenseTypeFraction: false,
        licenseTime: "",
        licenseStart: "",
        licenseEnd: "",
        licenseScope: "",
        licenseGzjNumber: "",
        licenseGzjDate: "",
        openLicenseMethod: [],
        licenseAmount: null,
        licenseCustom: "否",
        licenseCustomDate: "",
        licenseCustomScope: "",
        licenseCustomStyle: "",
        licenseOther: "否",
        licenseOtherDate: "",
        licenseOtherScope: "",
        licenseOtherConditions: "",
        stockFloorPrice: null,
        enterpriseStatus: "",
        selectionMethod: "公开挂牌",
        stockOtherConditions: "",
        otherFloorPrice: null,
        otherOtherConditions: "",
      },
      rules: {},
    };
  },
  computed: {
    dealWayArr() {
      if (!this.cfrom || !this.cfrom.dealWay) return [];
      return String(this.cfrom.dealWay).split(",").filter(Boolean);
    },
    hasTransfer() {
      return this.dealWayArr.includes("转让");
    },
    hasLicense() {
      return this.dealWayArr.includes("许可");
    },
    hasStock() {
      return this.dealWayArr.includes("作价入股");
    },
    hasOther() {
      return this.dealWayArr.includes("其他");
    },
    calculatedFloorPrice() {
      const a = parseFloat(this.form.transferFloorPrice) || 0;
      const b =
        parseFloat(
          this.form.licenseType === "开放许可"
            ? this.form.licenseAmount
            : this.form.licenseFloorPrice
        ) || 0;
      const c = parseFloat(this.form.stockFloorPrice) || 0;
      const d = parseFloat(this.form.otherFloorPrice) || 0;
      return a + b + c + d;
    },
  },
  methods: {
    buildValue() {
      const v = { ...this.form };
      v.floorPrice = this.calculatedFloorPrice;
      if (this.licenseDateRange && this.licenseDateRange.length === 2) {
        v.licenseStart = this.licenseDateRange[0];
        v.licenseEnd = this.licenseDateRange[1];
      }
      if (Array.isArray(v.openLicenseMethod)) {
        v.openLicenseMethod = v.openLicenseMethod.join(",");
      }
      if (this.id) v.id = this.id;
      return v;
    },
    doStaging(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) this.$emit("aStagin", this.buildValue());
      });
    },
    doSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) this.$emit("aChange", "tab5", this.buildValue());
      });
    },
  },
  watch: {
    cfrom: {
      deep: true,
      handler() {
        if (!this.cfrom) return;
        const c = this.cfrom;
        this.form = {
          additionCondition: c.additionCondition || "",
          priorityTransferee: c.priorityTransferee || "否",
          transferFloorPrice: c.transferFloorPrice || null,
          transferOtherConditions: c.transferOtherConditions || "",
          licenseType: c.licenseType || "",
          licenseFloorPrice: c.licenseFloorPrice || null,
          licenseTypeCross: !!c.licenseTypeCross,
          licenseTypeFraction: !!c.licenseTypeFraction,
          licenseTime: c.licenseTime || "",
          licenseStart: c.licenseStart || "",
          licenseEnd: c.licenseEnd || "",
          licenseScope: c.licenseScope || "",
          licenseGzjNumber: c.licenseGzjNumber || "",
          licenseGzjDate: c.licenseGzjDate || "",
          openLicenseMethod: c.openLicenseMethod
            ? typeof c.openLicenseMethod === "string"
              ? c.openLicenseMethod.split(",").filter(Boolean)
              : c.openLicenseMethod
            : [],
          licenseAmount: c.licenseAmount || null,
          licenseCustom:
            c.licenseCustom === 1 || c.licenseCustom === "1"
              ? "是 已自行实施专利技术"
              : c.licenseCustom || "否",
          licenseCustomDate: c.licenseCustomDate || "",
          licenseCustomScope: c.licenseCustomScope || "",
          licenseCustomStyle: c.licenseCustomStyle || "",
          licenseOther:
            c.licenseOther === 1 || c.licenseOther === "1"
              ? "是 已许可他人实施专利"
              : c.licenseOther || "否",
          licenseOtherDate: c.licenseOtherDate || "",
          licenseOtherScope: c.licenseOtherScope || "",
          licenseOtherConditions: c.licenseOtherConditions || "",
          stockFloorPrice: c.stockFloorPrice || null,
          enterpriseStatus: c.enterpriseStatus || "",
          selectionMethod: c.selectionMethod || "公开挂牌",
          stockOtherConditions: c.stockOtherConditions || "",
          otherFloorPrice: c.otherFloorPrice || null,
          otherOtherConditions: c.otherOtherConditions || "",
        };
        if (c.licenseStart && c.licenseEnd) {
          this.licenseDateRange = [c.licenseStart, c.licenseEnd];
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.tab_content {
  margin: 0 30px;
  .tab_title {
    font-size: 18px;
    font-weight: 500;
  }
  .tab_form {
    margin-top: 20px;
    .section-divider {
      font-size: 15px;
      font-weight: 500;
      color: #303133;
      margin: 20px 0 16px;
      padding: 8px 12px;
      background: #f5f7fa;
      border-left: 4px solid #409eff;
      border-radius: 0 4px 4px 0;
    }
    .hint {
      font-size: 12px;
      color: #909399;
      margin-left: 10px;
    }
    .button {
      button {
        width: 160px;
        margin: 0 24px;
        display: block;
      }
    }
  }
}
</style>
